import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["appointmentModalButton", "removeButtonPatientReturn", "filterContainer", "returnPatientDateFilter"]

  getAppointmentModal(event) {
    let timeNow = moment(new Date());
    //get time and sets to default duration of 30 minutes
    const endTime = timeNow.add(30, 'minutes');

    $(".fc-bgevent-container > .fc-bgevent").trigger("click")
      $.getScript(
      `/appointments/new?start=${timeNow.format("YYYY-MM-DD HH:mm")}&end=${endTime.format("YYYY-MM-DD HH:mm")}&patient_id=${event.target.id.split(" ")[0]}&professional_id=${event.target.id.split(" ")[1]}&patient_return_id=${event.target.id.split(" ")[2]}&return_date=${event.target.id.split(" ")[3] + " " + event.target.id.split(" ")[4]}`
    )
  }

  markPatientReturnAsRead(event) {
    let confirmButton = document.getElementsByClassName("swal2-confirm swal2-styled")

    if(confirmButton.length === 0) {
      return;
    } else {
      $.ajax({
      url: `/patient_returns/${event.target.id}`,
      method: "PATCH" ,
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
      },
      }).done((data) => {
        $(this.containerTarget).append(data)
      })
    }
  }

  showFilter() {
    if (this.filterContainerTarget.classList.contains("hidden")) {
      this.filterContainerTarget.classList.add("tw-flex")
      this.filterContainerTarget.classList.remove("hidden")
    } else {
      this.filterContainerTarget.classList.remove("tw-flex")
      this.filterContainerTarget.classList.add("hidden")
    }
  }

  filterReturnPatients() {
    let date = this.returnPatientDateFilterTarget.value

    $.ajax({
      url: "/modal_patient_returns",
      method: "GET" ,
      data: { date },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
    }).done((data) => {
      $(this.containerTarget).append(data)
    })
  }
}
